import { faHouseNight } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';

export const EmptyContent: FC = () => (
  <CardEmptyState
    image={<EmptyStateIcon icon={faHouseNight} />}
    message={
      <FormattedMessage id="project.overview.tasks_completed_late.empty.help_text" />
    }
  />
);
